module.exports = __webpack_public_path__ + "static/fonts/iconfont.2838051.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/iconfont.woff?t=1610088025011
// module id = gfEb
// module chunks = 78